import '../src/application/css/application.css'
import 'swiper/dist/css/swiper.css'
import ApplicationInitializer from '../src/application/js/application_initializer'

new ApplicationInitializer()
